import { ReactNode } from 'react'
import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils'

interface LoadingStateProps {
  message?: string
  icon?: ReactNode
  className?: string
}

export function LoadingState({
  message = 'Loading...',
  icon,
  className
}: LoadingStateProps) {
  return (
    <div className={cn('flex items-center justify-center h-64', className)}>
      <div className="text-center">
        {icon || <Loader2 className="h-8 w-8 mx-auto mb-4 text-muted-foreground animate-spin" />}
        <p className="text-muted-foreground">{message}</p>
      </div>
    </div>
  )
}